import content from '@/api/administrator/content-management'
import lang from '@/api/lang'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations,
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        include: 'content_type'
      },
      attrubutes
    )
    return content.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return content.store(data)
  },
  update(context, { id, data }) {
    return content.update(id, data)
  },
  status(context, { id, data }) {
    return content.status(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await content.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getLang(context) {
    return lang.get()
  },
  getContentType(context) {
    return content.getContentType()
  },
  upload(context, data) {
    return content.uploadImage(data)
  }
}
